import React from 'react';


const EscalationKPICard = ({ title, value, subtitle, trend, trendValue, icon, iconColor, iconBg }) => {
  const getTrendColor = () => {
    if (trend === 'up') return 'text-error';
    if (trend === 'down') return 'text-success';
    return 'text-muted-foreground';
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  return;

















};

export default EscalationKPICard;